import { Reveal, ChapterHeader } from "./Reveal";
import { CalendarClock, TimerReset, Wrench, ShieldCheck, Handshake, Store, Cog } from "lucide-react";
import { useLang } from "../i18n";

export const Services = () => {
  const { t } = useLang();
  const SERVICES = [
    { icon: CalendarClock, title: t("srv1t"), text: t("srv1x") },
    { icon: TimerReset, title: t("srv2t"), text: t("srv2x") },
    { icon: Wrench, title: t("srv3t"), text: t("srv3x") },
    { icon: ShieldCheck, title: t("srv4t"), text: t("srv4x") },
    { icon: Handshake, title: t("srv5t"), text: t("srv5x") },
    { icon: Store, title: t("srv6t"), text: t("srv6x") },
    { icon: Cog, title: t("srv7t"), text: t("srv7x") },
  ];

  return (
  <section id="sluzby" data-testid="services-section" className="py-20 lg:py-28 px-4 sm:px-8 max-w-7xl mx-auto">
    <ChapterHeader number="03" eyebrow={t("c3_eyebrow")} title={t("c3_title")} />

    <div className="grid sm:grid-cols-2 gap-4 lg:gap-6">
      {SERVICES.map((s, i) => (
        <Reveal key={s.title} delay={i * 0.07} className={i === SERVICES.length - 1 ? "sm:col-span-2" : ""}>
          <div data-testid={`service-card-${i}`}
            className="group relative border border-steelborder bg-steelcard p-8 lg:p-10 overflow-hidden hover:border-safety/60 transition-colors duration-300 h-full">
            <span className="absolute top-6 right-6 font-mono text-xs text-slate-600 group-hover:text-safety transition-colors duration-300">
              03.{i + 1}
            </span>
            <s.icon className="w-8 h-8 text-safety mb-6" />
            <h3 className="font-heading text-2xl font-bold uppercase tracking-wide text-slate-100 mb-3">{s.title}</h3>
            <p className="text-sm sm:text-base text-slate-400 leading-relaxed">{s.text}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
  );
};
